import React from 'react';
import { Grid, Typography } from "@material-ui/core";
import '../../App.css'
import './home.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';


function Featured() {
  const globalClasses = globalUseStyles()
  return (
    <ThemeProvider theme={theme}>
      <Container className={"featuredStyleWrapper"} maxWidth={false} component="section">
          <Container className={"featuredStyle"} maxWidth={false} component="section">
            <Grid className={globalClasses.containerVertPadding} container>
                <Grid className={globalClasses.containerSmall} container >
                  <Grid item xs={12} md={12}  >
                      <Typography variant="h1">Technology solutions that solves people’s problems.</Typography>
                      <Typography variant="body1">At Pantheon, we use an iterative, data driven approach to create user-centered technology products that help people.  </Typography>
                  </Grid>
                </Grid>
            </Grid>
          </Container>
      </Container>
    </ThemeProvider>
  );
};

export default Featured;